import React from 'react';
import Image from 'next/image';
import SalaryBenefitsCard from './SalaryBenefitsCard';
import SalaryExperienceCard from './SalaryExperienceCard';
import SalaryEducationCard from './SalaryEducationCard';
import { TAB_MAP, TAB_SALARY_AND_WELFARE } from '@/constants/job-title';
import salaryIcon from '@/assets/job-title/salay.png';

export type DataType = {
  label: string;
  range: number[];
}[];

const SalaryAndBenefits = () => {
  return (
    <>
      <div className="font-semibold text-2xl flex items-center mb-9 tablet:mb-10">
        <Image
          src={salaryIcon}
          alt="salary benefit icon"
          width={24}
          height={24}
        />
        <h2 className="ml-2 opacity-85">{TAB_MAP[TAB_SALARY_AND_WELFARE]}</h2>
      </div>
      <SalaryBenefitsCard />
      <SalaryExperienceCard />
      <SalaryEducationCard />
    </>
  );
};

export default SalaryAndBenefits;
